module.exports = __webpack_public_path__ + "img/finance_thumbnail-600x450.d7dda515.jpg";